import { useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { findPageTitle } from '../utils/menuUtils';

export default function PlaceholderPage() {
  const location = useLocation();
  const { permissions } = useAuth();
  const title = findPageTitle(permissions, location.pathname);

  return (
    <div className="page-card">
      <h2>{title}</h2>
      <p className="page-desc">此功能頁面開發中，選單與權限已就緒。</p>
      <p className="page-desc muted-path">{location.pathname}</p>
    </div>
  );
}
